import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import { useParams } from "react-router-dom";
import axios from "axios";
import courses from "../AdmissionFom/courses";

const AdmissionPaymentReceipt = () => {
 
  const [paymentStatus, setpaymentStatus] = useState("");
const dateTime = String(paymentStatus.addedon);
  const contentRef = useRef(null);
  const [date, time] = dateTime.split(" ");

  const Date = String(date).split("-")
  

  const handlePrint = () => {
    setTimeout(() => {
      const printContent = contentRef.current;

      const printWindow = window.open();

      printWindow.document.write(`
        <html>
          <head>
            <title>Student Fee Chalan</title>
            <style>


              li{
              margin:0;
               padding:0;
              }

              p{
              margin:0;
               padding:0
              }

              h1,h2,h3,h4,h5,h6{
               margin:0;padding:0
              }

              .Print-chalan-page-container-modal {
                border: 1px solid lightgray;
                height:900px;
              }

              .Print-chalan-page-header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                border-bottom: 1px solid lightgray;
                margin-bottom: 10px;
                padding: 10px;
              }

              .Print-chalan-page-header > img {
                width: 16%;
              }

              .Print-chalan-page-title {
                margin-bottom: 8px;
                color: #2c3e50;
                font-size: 23px;
                font-weight: 600;
              }

              .Print-chalan-page-content {
                  padding: 10px 10px;
              }
              .print-chalan-page-box {
                display: grid;
                grid-template-columns: 1fr 150px;
              }

              .print-chalan-page-student-details > ul {
                display: flex;
                gap: 10px;
                flex-direction: column;
              }

              .print-chalan-page-student-details > ul > li > div {
                display: flex;
                flex-direction: row;
                gap: 30px;
              }

              .print-chalan-page-student-details > ul > li > div > p:first-child {
                font-weight: 600;
              }

              .Print-chalan-page-section-title {
                margin-top: 0;
                color: #2c3e50;
                border-bottom: 1px solid lightgray;
                padding: 20px 0px; 
                text-align: center;
                margin-bottom: 0;
              }

              .Print-chalan-page-details{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 10px;
                padding: 20px;
              }

              .Print-chalan-page-detail-item{
                width: calc(90%/2);
                display: flex;
                flex-direction: row;
                gap: 10px;
              }

              .Print-chalan-page-detail-value{
                margin-bottom: 0px;
                text-align: end;
              }

              .Print-chalan-detail-label{
                font-weight: 600;
              }

              .Print-chalan-printable-content {
                display: block;
                padding: 20px;
                max-width: 900px;
                margin: auto;
              }

              .print-chalan-student-profile-image {
                width: 60%;
              }

              .print-chalan-student-signature-image {
                width: 60%; 
              }

              .Signature-box{
                border: 1px solid black;
                padding: 10px 100px;
              }

              .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}

              .Print-chalan-subtitle{
  margin-bottom: 10px;
}


              @media screen {

                .Print-chalan-printable-content {
                  display: block;
                  padding: 20px;
                  max-width: 900px;
                  margin: auto;
                }

                .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}
          
                .Print-chalan-page-container-modal {
                  border: 1px solid lightgray;
                   height:900px;
                }

                .Print-chalan-page-header {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  text-align: center;
                  border-bottom: 1px solid lightgray;
                  margin-bottom: 10px;
                  padding: 10px;
                }

                .Print-chalan-page-header > img {
                  width: 16%;
                }

                .Print-chalan-page-title {
                  margin-bottom: 8px;
                  color: #2c3e50;
                  font-size: 23px;
                  font-weight: 600;
                }

                .Print-chalan-page-content {
                    padding: 10px 10px;
                }
                .print-chalan-page-box {
                  display: grid;
                  grid-template-columns: 1fr 150px;
                }

                .print-chalan-page-student-details > ul {
                  display: flex;
                  gap: 10px;
                  flex-direction: column;
                }

                .print-chalan-page-student-details > ul > li > div {
                  display: flex;
                  flex-direction: row;
                  gap: 30px;
                }

                .print-chalan-page-student-details > ul > li > div > p:first-child {
                  font-weight: 600;
                }

                .Print-chalan-page-section-title {
                  margin-top: 0;
                  color: #2c3e50;
                  border-bottom: 1px solid lightgray;
                  padding: 20px 0px;
                  text-align: center;
                  margin-bottom: 0;
                }

                .Print-chalan-page-details{
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  gap: 10px;
                  padding: 20px;
                }

                .Print-chalan-page-detail-item{
                  width: calc(98%/2);
                  display: flex;
                  flex-direction: row;
                  gap: 10px;
                }

                .Print-chalan-page-detail-value{
                  margin-bottom: 0px;
                  text-align: end;
                }
                
                .Print-chalan-detail-label{
                  font-weight: 600;
                }

                .print-chalan-student-profile-image {
                  width: 60%;
                }

                .print-chalan-student-signature-image {
                  width: 60%; 
                }

                .Signature-box{
                  border: 1px solid black;
                  padding: 10px 100px;
                }

                .Print-chalan-subtitle{
  margin-bottom: 10px;
}

              }



              @media print {
                
                body {
                  padding: 15px;
                }

                .Signature-box {
    border: 1px solid black;
    padding: 30px 100px;
}

                .Print-chalan-detail-label{
                font-weight: 600;
                }

                .Print-chalan-section {
                  page-break-inside: avoid;
                }

                .Print-chalan-image-container {
                  page-break-inside: avoid;
                }

                
                .Print-chalan-printable-content {
                  display: block;
                  padding: 20px;
                  max-width: 900px;
                  margin: auto;
                }

                li{
                  margin:0;
                  padding:0;
                  list-style-type:none;
                }

                p{
                  margin:0;
                  padding:0
                }

                h1,h2,h3,h4,h5,h6{
                  margin:0;padding:0
                }


                .Print-chalan-page-container-modal {
                  border: 1px solid lightgray;
                   height:900px;
                }

                .Print-chalan-page-header {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  text-align: center;
                  border-bottom: 1px solid lightgray;
                  margin-bottom: 10px;
                  padding: 10px;
                }

                .Print-chalan-page-header > img {
                  width: 16%;
                }

                .Print-chalan-page-title {
                  margin-bottom: 8px;
                  color: #2c3e50;
                  font-size: 23px;
                  font-weight: 600;
                }

                .Print-chalan-page-content {
                    padding: 10px 10px;
                }

                .print-chalan-page-box {
                  display: grid;
                  grid-template-columns: 1fr 150px;
                }

                .print-chalan-page-student-details > ul {
                  display: flex;
                  gap: 10px;
                  flex-direction: column;
                }

                .print-chalan-page-student-details > ul > li > div {
                  display: flex;
                  flex-direction: row;
                  gap: 30px;
                }

                .print-chalan-page-student-details > ul > li > div > p:first-child {
                  font-weight: 600;
                  font-size:15px;
                }


                .Print-chalan-page-section-title {
                  margin-top: 0;
                  color: #2c3e50;
                  border-bottom: 1px solid lightgray;
                  padding: 20px 0px;
                  text-align: center;
                  margin-bottom: 0;
                }

                .Print-chalan-page-details{
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  gap: 10px;
                  padding: 20px;
                }

                .Print-chalan-page-detail-item{
                  width: calc(98%/2);
                  display: flex;
                  flex-direction: row;
                  gap: 10px;
                }


                .Print-chalan-page-detail-value{
                  margin-bottom: 0px;
                  text-align: end;
                }

                .print-chalan-student-profile-image {
                  width: 60%; 
                }

                .print-chalan-student-signature-image {
                  width: 60%;
                }

                .Signature-box{
                  border: 1px solid black;
                  padding: 30px 100px;
                }

                .Print-chalan-subtitle{
  margin-bottom: 10px;
}

                .Chalan-page-auth{
                  display: flex;
                    justify-content: end;
                    position: relative;
                    bottom: 0px;
                }

                .Chalan-page-auth > ul {
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                }

                .Chalan-page-auth > ul >li{
                  display: flex;
                  flex-direction: row; 
                  gap: 10px;
                }

                .Chalan-page-auth > ul > li > input{
                  margin: 0;
                } 

                .Chalan-page-auth > ul > span {
                  border: 1px solid black;
                  padding: 10px 40px;
                }
              }
             </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();

      printWindow.focus();

      // document.querySelector(".print-button-chalan-page").style.display =
      //   "none";

      printWindow.onload = function () {
        printWindow.print();

        printWindow.close();
      };
    }, 100);
  };



    

  


  const { id } = useParams();
  const [data, setData] = useState({});

  const loadResult = async () => {
    try {
      const printRes = await axios.post(
        "https://campus.acetians.in/api/v2/admission/print2",
        { admission_code: id }
      );
      setData(printRes.data[0]);
    } catch (error) {
      console.error("Error loading admission data:", error);
    }
  };

  useEffect(() => {
    loadResult();
  }, []);

  useEffect(() => {
    if (
      !data ||
      !Array.isArray(data.transactions) ||
      data.transactions.length === 0
    ) {
      setpaymentStatus("Pending");
    } else {
      const filtered = data.transactions.filter(
        (t) => t.amount > 50 && String(t.status).toLowerCase() === "success"
      );
      setpaymentStatus(
        filtered.length > 0 ? filtered[filtered.length - 1] : "Pending"
      );
    }
  }, [data]);

  if (!data || Object.keys(data).length === 0) {
    return <div>Loading...</div>;
  }



  return (
    <div
      style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}
      className="Print-chalan-main-container no-print"
    >
      <button className="print-button-chalan-page" onClick={handlePrint}>
        Print
      </button>
      <div ref={contentRef} className="Print-chalan-printable-content">
        <div className="Print-chalan-page-container-modal">
          <div className="Print-chalan-page-header">
            <img src="https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png" />
            <div>
              <h2
                // onClick={() => console.log(CouseCode)}
                className="Print-chalan-page-title"
                style={{fontSize:"20px"}}
              >
                रघुवीर सिंह राजकीय महाविद्यालय, ललितपुर,(उo.प्रo)
              </h2>

              {/* <button onClick={()=>console.log(paymentStatus)}>pay</button>
              <button onClick={()=>console.log(studentInformation)}>check</button> */}

              <p className="Print-chalan-subtitle">NAAC - B</p>
                 <p className="Print-chalan-subtitle"> Academic Year 2025-26</p>

                    <p className="Print-chalan-subtitle">Form-No : {data.id}</p>
           
            </div>
            <img
              src={"https://vbsgdc.org.in/uploads/2023/05/Uttar_Pradesh.png"}
            />
          </div>


             <div style={{border:"none"}} className="Print-chalan-page-section">
              <h3 style={{border:"none"}}  className="Print-chalan-page-section-title">
              Admission fee slip
              </h3>
            </div>

          <div className="Print-chalan-page-content">
            <div >
              <div className="print-chalan-page-student-details">
                <ul
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    justifyContent: "center",
                    gap:"20px",
                    marginBottom:"20px"
                  }}
                >
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Name:-</p>
                      <p>{data.applicant_name || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Father Name:-</p>
                      <p>{data.father_name || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Course Name:-</p>
                      <p>{data.course || ""}</p>
                    </div>
                  </li>

                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Course Year:-</p>
                      <p>{data.part === "1" ? "First Year" : (data.part === "2" ? "Second Year" : data.part === "3" && "Third Year")}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Caste Category:-</p>
                      <p>{data.category || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Gender:-</p>
                      <p>
                        {data.gender === "M"
                          ? "Male"
                          : data.gender === "F"
                          ? "Female"
                          : "Other"}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Date Of Birth:-</p>
                      <p>{data.dob || ""}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="Print-chalan-page-section">
              <h3 className="Print-chalan-page-section-title">
                Online Payment Details
              </h3>
            </div>

             <div >
              <div className="print-chalan-page-student-details">
                <ul
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    justifyContent: "center",
                    gap:"20px",
                    margin:"20px 0px"
                  }}
                >
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Date:-</p>
                      <p>{`${Date[Date.length-1]}/${Date[Date.length-2]}/${Date[Date.length-3]}` || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>transaction number:-</p>
                      <p>{paymentStatus.txnid || ""}</p>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Time:-</p>
                      <p>{time || ""}</p>
                    </div>
                  </li>

                  <li>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        justifyContent: "center",
                      }}
                    >
                      <p>Paid Amount:-</p>
                      <p>{`₹${paymentStatus.amount || "0"}`}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionPaymentReceipt;
